import gsap from "gsap";

// get other plugins:
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger); 


jQuery(document).ready(function(){
  let pinWrap = document.querySelector(".guide-wrapper");
  let pinWrapWidth = jQuery(pinWrap).innerWidth();
  let horizontalScrollLength = pinWrapWidth - jQuery('.wrapper_edito.section-guide').width();
  let headerHeight = jQuery('.header').height();
  if(jQuery('#guides').length != 0){
      let mm = gsap.matchMedia();
      mm.add("(min-width: 1025px)", () => {
        gsap.to('.guide-wrapper', {
          scrollTrigger: {
            trigger: '#guides',
            start: 'top-=' + headerHeight + ' top',
            scrub: true,
            pin: '#content',
          },
          x: -horizontalScrollLength - 50,
          ease: "none",
        });
    });
  }
    jQuery('#search-button, .menu-principal').animate({
      opacity: 1,
    }, 500);
  },1500);